//
//
//
//
//
//

export default {
  props: {
    caption: String,
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}
